import React, { useContext } from 'react'
import { EPCRContext } from '../EPCR'
import { TenantSettingsContext } from '../../../../App'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import PaediatricCO from '../Plan/PaediatricCO'

const FastTrackPlan = () => {
  const { formValues, handleChange } = useContext(EPCRContext)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  return (
    <EPCRCard>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title2">Plan</Typography>
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Patient Outcome</InputLabel>
            <Select
              value={formValues?.plan?.ptOutcome ?? ''}
              onChange={(e) =>
                handleChange({
                  moduleName: 'plan',
                  field: 'ptOutcome',
                  value: e.target.value,
                })
              }
              label="Patient Outcome"
            >
              <MenuItem value="Discharged following Treatment">
                Discharged following Treatment
              </MenuItem>
              <MenuItem value="Discharged - Advice Only">
                Discharged - Advice Only
              </MenuItem>
              <MenuItem value="Left before Treatment">
                Left before Treatment
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <PaediatricCO />
        <Grid item xs={12}>
          <TextField
            label="Advice Given"
            multiline
            fullWidth
            minRows={2}
            value={formValues?.plan?.adviceGiven}
            onChange={(e) =>
              handleChange({
                moduleName: 'plan',
                field: 'adviceGiven',
                value: e.target.value,
              })
            }
          />
        </Grid>
      </Grid>
    </EPCRCard>
  )
}

export default FastTrackPlan
